<form novalidate (ngSubmit)="buy()" [formGroup]="stripeTest" class="d-flex flex-wrap align-items-center">
	<!-- <input type="text" formControlName="name" placeholder="Jane Doe"> -->
	<ngx-stripe-card [options]="cardOptions" [elementsOptions]="elementsOptions" class="mb-3 col"></ngx-stripe-card>
	<button type="submit" class="btn btn-primary btn-post mb-3">
		BUY
	</button>
</form>